import { Schema, arrayOf } from 'normalizr';
import DuckEntity from './DuckEntity'

import { entity as userJobs } from './userJobs';
import { entity as contacts } from './contacts';

import { apiFetch, apiAction, getMetaContent } from 'utils';

import { compose } from 'redux';
import { denormalize } from 'denormalizr';

import {actionize} from 'utils';

const schema = new Schema('bulkFileWorkflows');
schema.define({
  bulk_file_ocr_job: userJobs.schema,
  bulk_file_commit_job: userJobs.schema
});

const duck = new DuckEntity('bulkFileWorkflows', {
  schema
});

let types = {
  LOAD: null,

  COMMIT: null,
  COMMIT_SUCCESS: null,
  COMMIT_ERROR: null,

  LOAD_APPLICABLE_CONTACTS: null,
  LOAD_APPLICABLE_CONTACTS_SUCCESS: null,
  LOAD_APPLICABLE_CONTACTS_ERROR: null
};
types = actionize(types, (action) => `schooladmin/bulkFileWorkflows/${action}`);

const applicableContacts = (state, bulkFileWorkflowId) => {
  const applicableContactsIds = state.bulkFileWorkflows.applicableContacts[bulkFileWorkflowId];

  let ret = denormalize(applicableContactsIds || [], state.entities, arrayOf(contacts.schema));
  ret.ready = !!applicableContactsIds;
  ret.pending = !ret.ready;
  ret.error = null;

  return ret;
};

// Action Creators
const commit = (bulkFileWorkflow) =>
  apiAction(
    types.COMMIT, types.COMMIT_SUCCESS, types.COMMIT_ERROR,
    (state) => apiFetch.post(state, `${duck.config.apiPath}/${bulkFileWorkflow.id}/commit`, {bulkFileWorkflow}, {/*options...*/}),
    {entityName: name, create: false, update: true, bulkFileWorkflow},
    { bulk_file_workflow: schema }
  );

const create = ({file, checklist_item_id, school_year_id}) => {
  let token = getMetaContent('csrf-token');
  const headers = {
    'Accept': 'application/json',
    'X-CSRF-Token': token
  };

  const actionParams = {
    file,
    checklist_item_id,
    school_year_id
  };

  var data = new FormData();
  for(let key in actionParams){
    data.append(`bulk_file_workflow[${key}]`, actionParams[key]);
  }

  return apiAction(
    duck.actions.SAVE_BEGIN, duck.actions.SAVE_SUCCESS, duck.actions.SAVE_ERROR,
    (state) => apiFetch.post(state, 'bulk_file_workflows', null, {rawBody: data, headers}),
    actionParams,
    { bulk_file_workflow: schema }
  );
};

const loadApplicableContacts = (bulkFileWorkflowId) =>
  apiAction(
    types.LOAD_APPLICABLE_CONTACTS, types.LOAD_APPLICABLE_CONTACTS_SUCCESS, types.LOAD_APPLICABLE_CONTACTS_ERROR,
    (state) => apiFetch.get(state, `${duck.config.apiPath}/${bulkFileWorkflowId}/applicable_contacts`, {}),
    {bulkFileWorkflowId},
    {contacts: arrayOf(contacts.schema)}
  );

const applicableContactsReducer = (state={}, action) => {
  switch(action.type){
    case types.LOAD_APPLICABLE_CONTACTS_SUCCESS:
      return {
        ...state,
        [action.bulkFileWorkflowId]: action.payload.result.contacts
      };
    default:
      return state;
  }
};

const initialState = {
  ...duck.initialState,
  applicableContacts: {}
};

const reducer = (state=initialState, action) => ({
  ...duck.reducer(state, action),
  applicableContacts: applicableContactsReducer(state.applicableContacts, action)
});

export default reducer;

export const entity = {
  ...duck,
  applicableContacts,
  actions: {
    ...duck.actions,
    ...types,
    commit,
    create,
    loadApplicableContacts
  }
};
